<template>
  <div
    class="relative w-40 aspect-[2/3] rounded-r-lg rounded-l-[4px] shadow-[20px_0_40px_-10px_rgba(0,0,0,0.4)] transform transition-transform duration-500 hover:scale-105 hover:-rotate-2 group-hover:shadow-[20px_10px_50px_-10px_rgba(0,0,0,0.5)]"
    :class="wrapperClass"
  >
    <div class="absolute left-0 top-0 bottom-0 w-1 bg-gradient-to-r from-white/20 to-transparent z-20 rounded-l-[4px]"></div>
    <img
      v-if="imageUrl"
      :src="imageUrl"
      :alt="alt"
      class="w-full h-full object-cover rounded-r-lg rounded-l-[2px] border-r border-t border-b border-white/10"
    />
    <div
      v-else
      class="w-full h-full rounded-r-lg rounded-l-[2px] bg-white/5 border-2 border-dashed border-white/30 flex flex-col items-center justify-center gap-2 px-3 py-4 text-center"
    >
      <i :class="placeholderIconClass" class="text-white/40 text-xl block"></i>
      <p class="text-[10px] font-medium text-white/70 leading-tight">{{ emptyLabel }}</p>
    </div>
    <div
      v-if="rating != null"
      class="absolute -right-4 top-4 bg-white/10 backdrop-blur-md border border-white/10 px-3 py-1.5 rounded-xl shadow-lg flex flex-col items-center"
      :class="ratingBadgeClass"
    >
      <i :class="ratingIconClass" class="text-[#ecd79f] text-sm mb-0.5 block"></i>
      <span class="text-xs font-bold text-white">{{ rating }}</span>
    </div>
  </div>
</template>

<script setup>
defineProps({
  imageUrl: { type: String, default: '' },
  alt: { type: String, default: 'Cover' },
  rating: { type: [String, Number], default: null },
  placeholderIconClass: { type: String, default: 'pr pr-gallery' },
  emptyLabel: { type: String, default: 'No cover image, please upload one.' },
  ratingIconClass: { type: String, default: 'pr pr-star' },
  ratingBadgeClass: { type: String, default: '' },
  wrapperClass: { type: String, default: '' }
});
</script>
